var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h4", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("Doughnut", { attrs: { "chart-data": _vm.declaration, height: 130 } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }